<template>
    <!-- app-level top bar in the build default colors: back arrow and build logo, like the native settings toolbar -->
    <v-app-bar app flat :color="appTheme.headerFooterColor" class="hl-app-bar">
        <v-btn icon large :ripple="false" @click="$emit('back')">
            <v-icon large :color="appTheme.footerIconColor">mdi-arrow-left</v-icon>
        </v-btn>
        <v-spacer/>
        <v-img :src="`${customBasePath}/logo.png`" max-height="45" :max-width="isXsDevice ? 100 : 150" contain/>
        <v-spacer/>
        <!-- same width as the back button so the logo stays centered -->
        <div class="hl-app-bar__balance"/>
    </v-app-bar>
</template>

<script>
import { layoutMixin } from '@/utils/layout-mixin';

export default {
    mixins: [layoutMixin],
};
</script>

<style scoped>
.hl-app-bar__balance {
    width: 44px;
}
</style>
